var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"invoice-button",class:{'invoice-button__disabled': _vm.disabled},attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleButtonClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }